import React from 'react';
import { Menu, MenuItem, Box, Divider } from '@mui/material';
import { Link } from 'react-router-dom';
import AccountIcon from '@mui/icons-material/AccountCircleOutlined';
import CustomizeIcon from '@mui/icons-material/Brush';
import LogoutIcon from '@mui/icons-material/LogoutOutlined';
import { SessionTimer } from './SessionTimer';
import { useSnackbar } from 'notistack';
import { logoutUser } from '@/hooks/acl';

interface UserMenuProps {
    anchorEl: null | HTMLElement;
    onClose: () => void;
    onChangingDesign: () => void;
    remainingSessionTime?: number;
}

export const UserMenu: React.FC<UserMenuProps> = ({ anchorEl, onClose, onChangingDesign, remainingSessionTime }) => {
    const snackbar = useSnackbar();

    const handleLogout = () => {
        logoutUser()
            .then(() => {
                window.location.href = '/login';
            })
            .catch((error) => {
                snackbar.enqueueSnackbar(error.message, { variant: 'error' });
            });
    };

    return (
        <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={onClose}
            // ... other menu props
        >
            <MenuItem>
                <SessionTimer timeRemaining={remainingSessionTime ?? 0} />
            </MenuItem>
            <Divider />
            <MenuItem component={Link} to="/account" onClick={onClose}>
                <AccountIcon sx={{ mr: 1 }} />
                Миний бүртгэл
            </MenuItem>
            <MenuItem onClick={onChangingDesign}>
                <CustomizeIcon sx={{ mr: 1 }} />
                Дизайн Тохиргоо
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleLogout}>
                <LogoutIcon sx={{ mr: 1 }} />
                Гарах
            </MenuItem>
        </Menu>
    );
};